'use strict';
let xgScript = {
    data() {
        return{
            applyReturnForm: {},
            xgValidateRules: {
                BEGIN_DATE: [{required: true, message: this.$t('pleaseSelectAStartTime'), trigger: ['blur','change']}],
                END_DATE: [{required: true, message: this.$t('pleaseSelectAnEndTime'), trigger: ['blur','change']}],
                BOX_ARR: [{required: true, message: this.$t('pleaseSelectTheBox'), trigger: ['blur','change']}],
            },
            xgForm: {
                BOX_ARR: []
            },
            xgBoxOptions: [],
            xgDetailShow: false,
            xgShow: false,
            xgList: [],
            cancelXgShow: false,
            cancelXgData: {}
        }
    },
    computed:{
        xgBoxLength(){
            let xgLength = 0;
            this.xgList.forEach(item =>{
                xgLength += item.BOX_CODE_ARR.length;
            })
            return xgLength;
        }
    },
    methods: {
        checkAllXh(e){
            let BOX_ARR = [];
            this.xgBoxOptions.forEach(item =>{
                if(!item.disabled){
                    BOX_ARR.push(item.value);
                }
            })
            this.$set(this.xgForm,'BOX_ARR',e.target.checked ? BOX_ARR : []);
        },
        cancelXgModal(){
            this.xgForm = {
                BOX_ARR: [],
            };
            this.xgShow = false;
        },
        createXgOrder(){
            this.$refs.xgForm.validate(val => {
                if (val) {
                    let condition = {};
                    let OT_XG_INFO = [];
                    this.xgForm.BOX_ARR.forEach(item => {
                        item = JSON.parse(item);
                        OT_XG_INFO.push({
                            "VOUCHER_ID": item.VOUCHER_ID,
                            "TARGET_ID": item.TARGET_ID,
                            "PARENT_FLOW_ID": item.PARENT_FLOW_ID,
                            "BOX_FLOW_ID": item.BOX_FLOW_ID,
                            "BOX_ID": item.BOX_ID,
                            "BEGIN_DATE": this.$moment(this.xgForm.BEGIN_DATE).format('YYYY-MM-DD'),
                            "END_DATE": this.$moment(this.xgForm.END_DATE).format('YYYY-MM-DD'),
                            XD_MASTER_ID : item.XD_MASTER_ID,
                            XD_SHEET_CODE : item.XD_SHEET_CODE,
                        })
                    })
                    condition.OT_XG_INFO = OT_XG_INFO;
                    if(this.loading){
                        this.loading = false;
                        this.$h5Api({
                            type: '4033',
                            data: [condition],
                        }).then(({data}) => {
                            this.xgShow = false;
                            this.$message.info("创建成功！");
                            this.getOrderDetail(this.$route.query.MASTER_ID);
                        }).finally(() =>{
                            this.loading = true;
                        })
                    }
                }
            })
        },
        openCancelXgModal(data){
            this.cancelXgData = Object.assign({},data);
            this.cancelXgShow = true;
        },
        cancelXg(data){
            let condition = {
                MASTER_ID: this.cancelXgData.MASTER_ID,
                DELETE_DESC: this.cancelXgData.DELETE_DESC,
            }
            if(this.loading) {
                this.loading = false;
                this.$h5Api({
                    type: '4034',
                    data: [condition],
                }).then(({data}) => {
                    this.xgShow = false;
                    this.$message.info("取消成功！");
                    this.getOrderDetail(this.$route.query.MASTER_ID);
                }).finally(() =>{
                    this.loading = true;
                })
            }
        },
        xgApply(){
            let condition = {
                MASTER_ID: this.orderForm.MASTER_ID
            }
            if(this.loading) {
                this.loading = false;
                this.$h5Api({
                    type: '4032',
                    data: [condition],
                }).then(({data}) => {
                    let xgBoxOptions = [];
                    data?.OT_XG_CREATE_INFO.forEach(item =>{
                        let xgData = {};
                        xgData.label = item.BOX_CODE;
                        xgData.value = JSON.stringify(item);
                        xgData.disabled = item.BOX_EX_STATUS;
                        xgData.XD_MASTER_ID = item.XD_MASTER_ID;
                        xgData.XD_SHEET_CODE = item.XD_SHEET_CODE;
                        xgBoxOptions.push(xgData);
                    })
                    this.xgBoxOptions = xgBoxOptions;
                }).finally(() =>{
                    this.loading = true;
                })
            }
        },
        openXgModal(){
            this.xgShow = true;
            this.xgApply();
        },
    },
    created() {
    }
};

export default xgScript;